<template>
    <!-- Top Stats Banner -->
    <BannerCarousel
        apiEndpoint="/realtime-stats/"
        :transformData="transformStats"
        :refetchOnLanguageChange="true"
        height="50px"
        backgroundColor="#fff005"
        textColor="#000000"
        itemMinWidth="300px"
        position="top"
        :zIndex="99"
        :speed="50"
    >
        <template #item="{ item }">
            <div class="text-center">
                <div style="font-weight:bold">{{ item.value }}</div>
                <span>{{ item.label }}</span>
            </div>
        </template>
    </BannerCarousel>

    <v-container class="landing-wrapper" fluid>
        <!-- MAIN FLEX SECTION -->
        <v-row>
            <v-col cols="12" :class="$vuetify.display.smAndDown
                    ? 'd-flex justify-space-between px-2 pt-8'
                    : 'd-flex justify-space-between px-10 pt-8'
                ">
                <v-btn @click="$router.push('/login')">
                    {{ $t("landingPage.login") }}
                </v-btn>
                <v-btn @click="$router.push('/register')">
                    {{ $t("landingPage.register") }}
                </v-btn>
            </v-col>

            <v-col cols="12" :class="$vuetify.display.smAndDown ? 'px-0' : 'px-10'">
                <v-row :class="$vuetify.display.smAndDown ? 'ma-0' : ''">
                    <v-col cols="12" sm="5" md="6" lg="6" class="text-center text-sm-start">
                        <div class="d-flex flex-column ga-2 align-center align-sm-start">
                            <h1 class="text-h3 font-weight-bold">
                                Mekonsm<br class="d-lg-none" /> Fracht
                            </h1>
                            <a href="https://www.firmadeincredere.ro/company,9471,mekonsm-consulting-s-r-l" target="_blank"
                                style="text-decoration: none; color: inherit;">
                                <div class="d-flex align-center justify-center justify-sm-start" style="gap: 12px">
                                    <img :src="`${$baseUrl}mekon_trusted_logo.png`"
                                        :alt="$t('landingPage.trustedCompanyBadge')" width="40" height="40"
                                        style="object-fit: contain" />
                                    <span class="font-weight-bold">
                                        {{
                                            $t(
                                                "landingPage.trustedCompanyBadge"
                                            ).toUpperCase()
                                        }}
                                    </span>
                                </div>
                            </a>
                            <h2 :style="{
                                backgroundColor: '#123666',
                                width: 'fit-content',
                                color: 'white',
                                padding: '6px 12px',
                                display: 'inline-flex',
                                alignItems: 'center',
                            }" class="text-h6 font-weight-bold mx-auto ms-sm-0" :class="$vuetify.display.smAndDown
                                        ? 'text-h5'
                                        : 'text-h4'
                                    ">
                                DELIVERING THE FUTURE
                                <v-icon color="white"
                                    :size="$vuetify.display.smAndDown ? 36 : 48">mdi-chevron-double-right</v-icon>
                            </h2>
                        </div>
                        <p
                            class="text-black font-weight-bold mt-2 mb-0 text-uppercase"
                            :class="$vuetify.display.smAndDown ? 'text-subtitle-1' : 'text-h6'"
                        >
                            Our freight exchange is dedicated to sprinters and urgent goods
                        </p>
                    </v-col>

                    <v-col cols="12" sm="7" md="6" lg="6"
                        class="d-flex flex-column ga-5 text-center text-sm-end align-center align-sm-end">
                        <LandingPageLink routerLink="/policy/about">
                            {{ $t("landingPage.aboutUs").toUpperCase() }}
                        </LandingPageLink>
                        <LandingPageLink routerLink="/prices">
                            {{ $t("landingPage.prices").toUpperCase() }}
                        </LandingPageLink>
                        <LandingPageLink routerLink="/useful-links">
                            {{ $t("landingPage.usefulLinks").toUpperCase() }}
                        </LandingPageLink>
                        <LandingPageLink routerLink="/policy/terms">
                            {{
                                $t(
                                    "landingPage.termsAndConditions"
                                ).toUpperCase()
                            }}
                        </LandingPageLink>

                        <LandingPageLink routerLink="/policy/privacy">
                            {{ $t("landingPage.privacyPolicy").toUpperCase() }}
                        </LandingPageLink>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row :class="$vuetify.display.smAndDown ? 'px-2' : 'px-10'" class="flex-grow-0">
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-card class="landing-page-cards no-ellipsis">
                    <v-img :src="`${$baseUrl}card-images/card1.webp`" cover height="330"
                        gradient="to bottom, rgba(255,255,255,0.85), rgba(255,255,255,0.85)">
                        <div class="img-overlay-content">
                            <span class="yellow-rectangle"></span>
                            <div class="text-h6 font-weight-bold card-title">
                                {{ $t("landingPage.cardTitle1").toUpperCase() }}
                            </div>
                            <div class="text-subtitle-2 font-weight-bold text-justify">
                                {{ $t("landingPage.cardContent1") }}
                            </div>
                        </div>
                    </v-img>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-card class="landing-page-cards no-ellipsis">
                    <v-img :src="`${$baseUrl}card-images/card2.webp`" cover height="330"
                        gradient="to bottom, rgba(255,255,255,0.85), rgba(255,255,255,0.85)">
                        <div class="img-overlay-content">
                            <span class="yellow-rectangle"></span>
                            <div class="text-h6 font-weight-bold card-title">
                                {{ $t("landingPage.cardTitle2").toUpperCase() }}
                            </div>
                            <div class="text-subtitle-2 font-weight-bold text-justify">
                                {{ $t("landingPage.cardContent2") }}
                            </div>
                        </div>
                    </v-img>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-card class="landing-page-cards no-ellipsis">
                    <v-img :src="`${$baseUrl}card-images/card3.webp`" cover height="330"
                        gradient="to bottom, rgba(255,255,255,0.85), rgba(255,255,255,0.85)">
                        <div class="img-overlay-content">
                            <span class="yellow-rectangle"></span>
                            <div class="text-h6 font-weight-bold card-title">
                                {{ $t("landingPage.cardTitle3").toUpperCase() }}
                            </div>
                            <div class="text-subtitle-2 font-weight-bold text-justify">
                                {{ $t("landingPage.cardContent3") }}
                            </div>
                        </div>
                    </v-img>
                </v-card>
            </v-col>
            <v-col cols="12" sm="6" md="4" lg="3">
                <v-card class="landing-page-cards no-ellipsis">
                    <v-img :src="`${$baseUrl}card-images/card4.webp`" cover height="330"
                        gradient="to bottom, rgba(255,255,255,0.85), rgba(255,255,255,0.85)">
                        <div class="img-overlay-content">
                            <span class="yellow-rectangle"></span>
                            <div class="text-h6 font-weight-bold card-title">
                                {{ $t("landingPage.cardTitle4").toUpperCase() }}
                            </div>
                            <!-- use v-html on each list piece -->
                            <div>
                                <div class="text-subtitle-2 font-weight-bold text-justify"
                                    v-html="$t('landingPage.cardContent4list1')"></div>
                                <div class="text-subtitle-2 font-weight-bold text-justify"
                                    v-html="$t('landingPage.cardContent4list2')"></div>
                                <div class="text-subtitle-2 font-weight-bold text-justify"
                                    v-html="$t('landingPage.cardContent4list3')"></div>
                            </div>
                        </div>
                    </v-img>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
        <!-- Bottom Logo Banner -->
        <BannerCarousel
        apiEndpoint="/bottom-banner-logos/"
        height="90px"
        backgroundColor="#0b2b5c"
        itemMinWidth="auto"
        position="bottom"
        :zIndex="100"
        :speed="30"
    >
        <template #item="{ item }">
            <a
                :href="item.url"
                target="_blank"
                rel="noopener noreferrer"
                style="display:flex; align-items:center; text-decoration:none"
            >
                <img
                    :src="item.logo"
                    style="
                        max-height:70px;
                        max-width:200px;
                        object-fit:contain;
                        transition:transform 0.2s ease;
                    "
                    @mouseover="$event.target.style.transform = 'scale(1.1)'"
                    @mouseleave="$event.target.style.transform = 'scale(1)'"
                />
            </a>
        </template>
    </BannerCarousel>
</template>

<script>
import BannerCarousel from "@/components/BannerCarousel.vue";
import LandingPageLink from "@/components/LandingPageLink.vue";

export default {
    components: {
        BannerCarousel,
        LandingPageLink,
    },
    methods:{
        transformStats(data) {
            return [
                {
                    value:data.truck_last_24h,
                    label:this.$t("bannerStats.trucks24h"),
                },
                {
                    value: data.ware_last_24h,
                    label:this.$t("bannerStats.wares24h"),
                },
                {
                    value: data.active_users,
                    label:this.$t("bannerStats.totalUsers"),
                },
                {
                    value:data.available_trucks,
                    label:this.$t("bannerStats.totalTrucks"),
                },
                {
                    value:data.available_wares,
                    label: this.$t("bannerStats.totalWares"),
                },
            ];
        },
    },
};
</script>

<style scoped>
.landing-wrapper {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    padding: 50px 0 100px 0;
}

.no-ellipsis .v-card-title {
    white-space: normal !important;
}

.landing-page-cards {
    min-height: 250px;
    border-radius: 8px;
    height: 100%;
}

.yellow-rectangle {
    display: block;
    top: 20;
    background-color: #fff005;
    width: 40px;
    height: 7px;
}

.img-overlay-content {
    position: absolute;
    inset: 0;
    gap: 20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: 16px;
    z-index: 1;
    color: #123666;
}

@media (max-width: 960px) {
    .landing-wrapper {
        padding: 50px 12px 100px 12px;
    }
}
</style>
